import { Card, Stack, Tab, Tabs, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import PropTypes from 'prop-types';

import TemplateSelectionControl from "./TemplateSelectionControl";
import { useUpdateSKUMutation } from "../features/products/productSlice";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 1 }}>
            {children}
          </Box>
        )}
      </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};
  
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const TemplateSideTabs = ({sku, skuimages, onChange}) => {
    const [value, setValue] = useState(0);
    const [updateSKU, {isLoadingUpdate: isUpdating }] = useUpdateSKUMutation();

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    const templateSelect = (event) => {
        console.log(event)
        var updateData = {}
        if (event.side === "front") {
            updateData.front_template = event.id
        }
        if (event.side === "back") {
            updateData.back_template = event.id
        }
        updateSKU({sku_id: sku.id, data: updateData});
        onChange();
    }

    if (!sku) {
      return <></>
    }
    let front_skuimage = null;
    let back_skuimage = null;
    if(skuimages) {
      skuimages.objects.forEach((skuimage) => {
        if(skuimage.purpose === "preview") {
          front_skuimage = skuimage;
        } else if (skuimage.purpose === "preview_back") {
          back_skuimage = skuimage;
        }
      })
    }

    return <Card variant="outlined">
        <Tabs value={value} onChange={handleChange}>
            <Tab label="Front template" {...a11yProps(0)} />
            <Tab label="Back template" {...a11yProps(1)} />
        </Tabs>
        <TabPanel value={value} index={0}>
            <Stack direction="column" spacing={2}>
                <TemplateSelectionControl sku={sku} templateId={sku.front_template} skuimage={front_skuimage} productFamilyId={sku.product_family} side="front" onChange={templateSelect}/>
            </Stack>
        </TabPanel>
        <TabPanel value={value} index={1}>
            <Stack direction="column" spacing={2}>
                <TemplateSelectionControl sku={sku} templateId={sku.back_template} skuimage={back_skuimage} productFamilyId={sku.product_family} side="back" onChange={templateSelect}/>
            </Stack>
        </TabPanel>
        </Card>;
}

export default TemplateSideTabs;
